var _a;
import { __decorate, __metadata } from "tslib";
import { Vue, Component, Prop, Ref, Inject } from 'vue-property-decorator';
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import { WECHAT_LOOP_TIMES, WECHAT_LOOP_INTERVAL, E_WECHAT_CODE_SCAN_TYPE, E_WECHAT_STATUS, } from './types';
import { getWechatIdentifyTokenApi, getWechatQrcodeApp, wechatIdentifyTokenLoginApi, wechatIdentifyTokenLoginWithInvitationCodeApi } from 'library-components/apis/wechat/wechat';
import _ from 'lodash';
import { Toast } from 'patsnap-biz';
import { PendoInsertMeta } from 'library-components/services/sentry';
import WechatBindDialog from '../WechatBindDialog/WechatBindDialog.vue';
import { applyAuthInterceptor, applyTenantIdInterceptor } from 'library-components/config/authInterceptor';
import { E_LoginMethod } from 'library-components/apis/login/login.type';
import { getAllVarsForLogin, postVar } from 'library-components/utils/environment';
import { registerUrlParamKeys } from 'library-components/apis/register/register.type';
import { jumpTo } from '@/infrastructure/utils/jump';
import { E_ConfirmResult } from 'library-components/utils/task';
import { MultiTenantSelectService } from '@/services/multiTenantSelectService';
import { TrialTermsMsgBoxService } from '@/services/trialTermsMsgBoxService';
let WechatCodeImpl = class WechatCodeImpl extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.wechatStatus = E_WECHAT_STATUS;
        this.codeStatus = E_WECHAT_STATUS.LOADING;
        this.codeSrc = '';
        this.wechatBindDialog = {
            visible: false,
            callbackValue: '',
        };
        this.multiTenantSelectService = new MultiTenantSelectService({
            selector: '.login-panel-body',
            i18n: this.$i18n,
        });
        this.trialTermsMsgBoxService = new TrialTermsMsgBoxService({
            selector: '.login-panel-body',
            i18n: this.$i18n,
        });
    }
    get needFresh() {
        return this.codeStatus === E_WECHAT_STATUS.OVERDUE || this.codeStatus === E_WECHAT_STATUS.SCANNED || this.codeStatus === E_WECHAT_STATUS.FAIL;
    }
    async sendVerificationCode(status) {
        if (status && this.codeStatus !== E_WECHAT_STATUS.OVERDUE && this.codeStatus !== E_WECHAT_STATUS.SCANNED && this.codeStatus !== E_WECHAT_STATUS.FAIL) {
            return;
        }
        this.codeStatus = E_WECHAT_STATUS.LOADING;
        this.isLoading = true;
        let rt;
        try {
            rt = await getWechatQrcodeApp(this.commonService.CurrentAppName);
        }
        catch {
            Toast({
                type: 'error',
                message: this.$t('passport.wechat.qrcodeError'),
                showClose: true,
                duration: 3000,
            });
        }
        let times = WECHAT_LOOP_TIMES;
        if (rt) {
            const queryUserInfo = async (callbackValue) => {
                times--;
                if (times === 0) {
                    this.codeStatus = E_WECHAT_STATUS.OVERDUE;
                    clearInterval(this.timerId);
                }
                let _rt;
                if (this.type === E_WECHAT_CODE_SCAN_TYPE.LOGIN) {
                    // 微信登录callback
                    try {
                        _rt = await getWechatIdentifyTokenApi({ callback_value: callbackValue });
                        if (!_.isEmpty(_rt)) {
                            clearInterval(this.timerId);
                            this.codeStatus = E_WECHAT_STATUS.SCANNED;
                            this.wechatScanCallBack(_rt, callbackValue);
                            PendoInsertMeta('Login', 'Scan Wechat Code');
                        }
                    }
                    catch (e) {
                        const status = _.get(e, 'response.status');
                        let errorCode = _.get(e, 'response.data.errcode') || _.get(e, 'response.data.numeric_error_code');
                        if (status === 500) {
                            // 服务器错误直接-1
                            // passport服务错误中也有 `number_error_code`
                            errorCode = -1;
                        }
                        clearInterval(this.timerId);
                        this.onIdentifyError({ errcode: errorCode });
                    }
                }
            };
            // 开始轮询
            this.codeSrc = rt.pic_url;
            this.timerId = setInterval(() => queryUserInfo(rt.callback_value), WECHAT_LOOP_INTERVAL);
            this.isLoading = false;
        }
    }
    onWechatImgLoadError(e) {
        this.codeStatus = E_WECHAT_STATUS.FAIL;
        clearInterval(this.timerId);
    }
    onWechatImgLoad(e) {
        this.codeStatus = E_WECHAT_STATUS.SUCCESS;
    }
    onCloseWechatBindDialog() {
        this.wechatBindDialog.visible = false;
    }
    wechatScanCallBack(identifyParams, callbackValue) {
        const { account_token, identify_token } = identifyParams;
        if (account_token) {
            // 已绑定直接登录
            const params = {
                identify_token,
                client_id: _.get(this.commonService, 'client_id'),
            };
            this.wechatLogin(params);
        }
        else {
            // 开启域名限制需要提示扫码
            if (this.commonService.DomainRestriction) {
                this.$emit('passport-error', {
                    message: this.$t('passport.wechat.domainRestriction', { url: this.SigupUrl }),
                });
                return;
            }
            // 未绑定 需绑定账号
            this.wechatBindDialog.callbackValue = callbackValue;
            this.wechatBindDialog.visible = true;
        }
    }
    get IsInvitationRegister() {
        if (this.commonService.IsPersonalInvitation && !_.isEmpty(this.invitationUser)) {
            return true;
        }
        if (this.commonService.IsInvitationSortCodeLink && !_.isEmpty(this.invitationCompany)) {
            return true;
        }
        return false;
    }
    trialTermsMsgBox(terms_update = false) {
        return this.trialTermsMsgBoxService.init(terms_update, {
            privacyPolicy: this.commonService.PrivacyPolicy,
            termsOfService: this.commonService.TermsOfService,
        });
    }
    async beforeLoginCheck(params, loginType, needSelectTenant = true) {
        if (needSelectTenant) {
            const tenantResult = await this.multiTenantSelectService.init(params, loginType).catch((error) => {
                this.$emit('passport-error', {
                    errcode: _.get(error, 'response.data.numeric_error_code'),
                });
            });
            if (!tenantResult || tenantResult === E_ConfirmResult.CANCEL) {
                return;
            }
        }
        const multiData = await this.loginService.getPreLoginData(params, loginType);
        if (multiData) {
            const { exceeded, trial_terms, company_limited, token, strong_password_need, terms_update, } = multiData;
            if (trial_terms || terms_update) {
                // terms_update 为true trial_terms为false才弹最新条款
                const res = await this.trialTermsMsgBox(terms_update && !trial_terms);
                if (res !== E_ConfirmResult.CONFIRM) {
                    return;
                }
            }
            if (exceeded) {
                let message = this.$t('passport.logined_in_other_place');
                if (company_limited) {
                    message = this.$t('passport.maximum_company_logins_reached');
                }
                const res = await this.$msgbox({
                    message,
                    showCancelButton: true,
                    cancelButtonClass: 'patsnap-el-cancel',
                    confirmButtonClass: 'patsnap-el-confirm',
                    confirmButtonText: this.$t('passport.common.agree'),
                    cancelButtonText: this.$t('passport.common.cancel'),
                    closeOnClickModal: false,
                    showClose: false,
                }).catch((e) => {
                    return e;
                });
                if (res !== 'confirm') {
                    return;
                }
            }
            if (token) {
                const href = this.loginService.getResetPasswordUrl({
                    ...params,
                    token,
                    strong_password_need,
                    tenant_id: this.multiTenantSelectService.TenantId,
                }, loginType);
                jumpTo(href);
                return;
            }
            return true;
        }
    }
    async wechatLogin(params) {
        try {
            // @ts-ignore
            const needSelectTenant = !(this.commonService.InvitationSortCode && this.IsInvitationRegister);
            if (!needSelectTenant) {
                applyTenantIdInterceptor(this.loginService.invitationData.companyId);
            }
            const checkStatus = await this.beforeLoginCheck(params, E_LoginMethod.wechat, needSelectTenant);
            if (!checkStatus)
                return;
            let tokenRes;
            if (this.commonService.InvitationSortCode && this.IsInvitationRegister) {
                tokenRes = await wechatIdentifyTokenLoginWithInvitationCodeApi({ ...params, invitation_code: this.commonService.InvitationSortCode });
            }
            else {
                tokenRes = await wechatIdentifyTokenLoginApi(params);
            }
            if (tokenRes.token) {
                applyAuthInterceptor(tokenRes.token);
                this.loginService.loginSuccess();
            }
        }
        catch (e) {
            let errorCode = _.get(e, 'response.data.errcode') || _.get(e, 'response.data.numeric_error_code');
            const loginUrl = _.get(e, 'response.data.loginurl');
            const status = _.get(e, 'response.status');
            if (status === 500) {
                // 服务器错误直接-1
                // passport服务错误中也有 `number_error_code`
                errorCode = -1;
            }
            errorCode === 30101 && (errorCode = 30101.1);
            errorCode === 30103 && (errorCode = 30103.1);
            if (errorCode) {
                if (errorCode === 30171) {
                    this.onIdentifyError({
                        message: this.$t('passport.wechat.domainRestriction', { url: this.SigupUrl }),
                    });
                    return;
                }
                this.onIdentifyError({
                    errcode: errorCode,
                    loginUrl,
                });
            }
        }
    }
    get invitationUser() {
        return this.loginService.invitationData.invitationUser;
    }
    get invitationCompany() {
        return this.loginService.invitationData.invitationCompany;
    }
    get SigupUrl() {
        const params = getAllVarsForLogin(['from', 'redirect_uri', 'client_id', 'c', 'c_type', ...registerUrlParamKeys]);
        const paramsStr = postVar({ ...params });
        const url = `${this.commonService.AccountHost}/public/?${paramsStr}#/register`;
        return url;
    }
    onIdentifyError(error) {
        if (error) {
            this.$emit('passport-error', error);
        }
    }
    created() {
        this.sendVerificationCode();
    }
    beforeDestroy() {
        clearInterval(this.timerId);
    }
};
__decorate([
    Inject('commonService'),
    __metadata("design:type", Object)
], WechatCodeImpl.prototype, "commonService", void 0);
__decorate([
    Inject('loginService'),
    __metadata("design:type", Object)
], WechatCodeImpl.prototype, "loginService", void 0);
__decorate([
    Prop({
        type: String,
        default: E_WECHAT_CODE_SCAN_TYPE.LOGIN,
    }),
    __metadata("design:type", Object)
], WechatCodeImpl.prototype, "type", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_a = typeof HTMLImageElement !== "undefined" && HTMLImageElement) === "function" ? _a : Object)
], WechatCodeImpl.prototype, "wechatImageRef", void 0);
WechatCodeImpl = __decorate([
    Component({
        name: 'WechatCode',
        components: {
            PtIcon,
            WechatBindDialog,
        },
    })
], WechatCodeImpl);
export { WechatCodeImpl };
